import { Link } from "react-router-dom";
import LeakCard from "@/components/feature/LeakCard";
import { leaks } from "@/mocks/leaks";

export default function LatestSection() {
  const [featured, ...rest] = leaks;
  const gridItems = rest.slice(0, 3);

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-medium tracking-widest text-primary-600">LATEST · 最新爆料</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            抢先看首发现场
          </h2>
        </div>
        <Link
          to="/feed"
          className="inline-flex items-center gap-1 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          查看全部爆料
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8">
        <LeakCard leak={featured} variant="wide" />
      </div>

      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {gridItems.map((leak) => (
          <LeakCard key={leak.id} leak={leak} />
        ))}
      </div>
    </section>
  );
}